import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileServiceService } from '../service/file-service.service';
import { FileCaptureService, ValidateReferralResponse } from '../service/file-capture.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { ProgressService } from 'app/service/progress.service';
import { AuthService } from 'app/service/auth-service';
import { map } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  error: boolean = false;
  errorMessage: string = '';
  private readonly MSG_INVALID = 'The Reference ID entered is not valid, please click on the Clear button and try again.';
  private readonly MSG_IN_USE = 'Please use a different Reference ID as this one is currently being used by another user.';
  progressMessage: string;
  referenceForm: FormGroup = new FormGroup({
    referenceNumber: new FormControl('', [Validators.required, Validators.maxLength(60)])
  });
  isUrlDisabled: boolean = true;
  securityCode: any;
  showLoader: boolean = true;
  payorKey: number;
  // <LLM_CODE_BEGIN story="US_826609">
  fileCaptureConfig: any = null;
  isInstructionsEnabled: boolean = false;
  instructionText: string = '';
  // <LLM_CODE_END story="US_826609">

  constructor(private route: Router, private service: FileServiceService,
    private fcservice: FileCaptureService, private ngxspinner: NgxSpinnerService, private authService: AuthService,
    private router: Router, private modalService: NgbModal) {
    this.ngxspinner.show();
    this.securityCode = router.url.replace("/", "");
    this.authService.setIsLoggedIn(false);
  }

  ngOnInit() {
    let refId = this.service.referenceFileDetails.referenceId;

    if (!refId) {
      refId = window.localStorage.getItem('referenceId') || '';
      this.service.referenceFileDetails.referenceId = refId;
    }

    this.referenceForm.get('referenceNumber')?.setValue(refId);
    // <LLM_CODE_BEGIN story="US_826609">
    // Load FileCapture config to check if instructions are enabled
    this.fcservice.getFileCaptureConfig(this.securityCode).subscribe(
      (config) => {
        this.fileCaptureConfig = config;
        this.isInstructionsEnabled = config && config.InstructionEnabled;
        const instruction = config?.Instruction || config?.instruction || '';
        this.instructionText = instruction ? instruction.replace('<img ', '<img title="Header" ') : '';
        this.showLoader = false;
        this.ngxspinner.hide();
        if (config == null || config.PayorKey == null || config.UrlStatus != 1) {
          this.isUrlDisabled = true;
          return;
        }
        this.payorKey = config.PayorKey;
        window.sessionStorage.setItem(this.fcservice.PAYOR_KEY, String(this.payorKey));
        window.localStorage.setItem('securityCode', this.securityCode);
        this.isUrlDisabled = false;
      },
      (error) => {
        console.error('Error loading FileCapture config:', error);
        this.isInstructionsEnabled = false;
      }
    );
    // <LLM_CODE_END story="US_826609">    
  }



  private releaseLock(): void {
    const sessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY);
    const refId = this.referenceForm.get('referenceNumber')?.value || this.service.referenceFileDetails.referenceId;
    if (sessionId && refId && this.payorKey) {
      this.fcservice.releaseReferenceLock(refId, this.payorKey, sessionId).subscribe();
      window.sessionStorage.removeItem(this.fcservice.SESSION_KEY);
    }
  }

  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    this.releaseLock();
  }

  clear() {
    this.releaseLock();
    this.referenceForm.get('referenceNumber')?.setValue('');
    this.error = false;
    this.errorMessage = '';
  }

  Next() {
    this.ngxspinner.show();
    this.error = false;
    this.errorMessage = '';
    this.service.referenceFileDetails.referenceId = this.referenceForm.get('referenceNumber')?.value;
    this.service.setCacheForitems(
      [{ id: "referenceId", value: this.service.referenceFileDetails.referenceId }]
    );
    if (this.referenceForm.get('referenceNumber')) {
      let sessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY) || '';
      this.fcservice.getReferenceId(this.referenceForm.get('referenceNumber')?.value, this.payorKey, sessionId).subscribe((res: ValidateReferralResponse) => {
        this.ngxspinner.hide();
        if (res?.sessionId) {
          window.sessionStorage.setItem(this.fcservice.SESSION_KEY, res.sessionId);
        }
        const isValid = res?.isValid === true;
        const isInUse = res?.isInUse === true;

        if (isInUse) {
          this.error = true;
          this.errorMessage = this.MSG_IN_USE;
          return;
        }

        if (isValid) {
          this.route.navigate(['reference']);
        } else {
          this.error = true;
          this.errorMessage = this.MSG_INVALID;
        }
      }, error => { this.ngxspinner.hide(); });
    }
  }

  // <LLM_CODE_BEGIN story="US_826609">
  showInstructions(): void {
    if (!this.instructionText) {
      return;
    }

    const modalRef = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    modalRef.componentInstance.name = this.instructionText;
  }
  // <LLM_CODE_END story="US_826609">

}
